module.exports = __webpack_public_path__ + "static/media/websitesoftwaresection.950eeb51.gif";